import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { createIconTextBannerComponent } from '@vfde-brix/ws10/icon-text-banner';

/**
 * Mount icon text banner component
 */
export const mountIconTextBanner = (id: HtmlId) =>
    mountComponent(id, createIconTextBannerComponent, NO_PATTERN_BUSINESS_LOGIC);
